import {
  ListDocumentTypesResponseDto
} from '@features/setting/application/use_cases/list-document-types/dto/list-document-types.response.dto';
import {
  ListDocumentTypesPayloadDto
} from '@features/setting/application/use_cases/list-document-types/dto/list-document-types.payload.dto';

import {
  ListDocumentTypesHttpResponseDto
} from '@features/setting/infrastructure/http/list-document-types/list-document-types.http.response.dto';
import {
  ListDocumentTypesHttpPayloadDto
} from '@features/setting/infrastructure/http/list-document-types/list-document-types.http.payload.dto';

export class ListDocumentTypesHttpMapper {

  static toResponse(data: ListDocumentTypesHttpResponseDto): ListDocumentTypesResponseDto {
    return {
      data: data.data.map(item => ({
        id: item.code,
        code: item.code,
        label: item.name,
        abbreviation: item.abbreviation,
      }))
    }
  }

  static toInfra(data: ListDocumentTypesPayloadDto): ListDocumentTypesHttpPayloadDto {
    return {}
  }

}
